import React from "react";
import styled from "styled-components";
import { Alert } from "@mui/material";
import { IconButton, Snackbar } from "@mui/material";
import { X } from "react-feather";
import useGlobalStore from "src/store/useGlobalStore";
// Takes the last word from snackbarText and use it for severity
// Everytime you set a snackbarText make sure the last word is one of
// ["info", "success", "warning", "error"]

const Close = styled(X)`
  color: ${(props) => props.theme.palette.primary.light};
`;

const transformText = (text) => {
  const split = text.trim().split(" ");
  const last = split.pop();
  return { text: split.join(" "), severity: last };
};

const GlobalSnackbar = () => {
  const snackbarText = useGlobalStore((state) => state.snackbarText);
  const clearSnackbarText = useGlobalStore((state) => state.clearSnackbarText);

  if (!snackbarText) return null;

  const { text, severity } = transformText(snackbarText);

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      open={snackbarText}
      onClose={() => clearSnackbarText()}
      autoHideDuration={7000}
      disableWindowBlurListener
      key={snackbarText}
      transitionDuration={{
        enter: 300,
        exit: 60,
      }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          onClick={() => clearSnackbarText()}
        >
          <Close fontSize="small" />
        </IconButton>
      }
    >
      <Alert
        severity={severity}
        variant="filled"
        onClose={() => clearSnackbarText()}
      >
        {text}
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;
